import React from 'react';
import { VehicleStatus } from '../../types/vehicle';

interface VehicleStatusBadgeProps {
  status: VehicleStatus;
  className?: string;
}

const VehicleStatusBadge: React.FC<VehicleStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusConfig = (status: VehicleStatus) => {
    switch (status) {
      case VehicleStatus.AVAILABLE:
        return {
          label: 'Available',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          dotColor: 'bg-green-400'
        };
      case VehicleStatus.RENTED:
        return {
          label: 'Rented',
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800',
          dotColor: 'bg-blue-400'
        };
      case VehicleStatus.MAINTENANCE:
        return {
          label: 'Maintenance',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          dotColor: 'bg-yellow-400'
        };
      case VehicleStatus.OUT_OF_SERVICE:
        return {
          label: 'Out of Service',
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          dotColor: 'bg-red-400'
        };
      case VehicleStatus.RESERVED:
        return {
          label: 'Reserved',
          bgColor: 'bg-purple-100',
          textColor: 'text-purple-800',
          dotColor: 'bg-purple-400'
        };
      default:
        return {
          label: 'Unknown',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          dotColor: 'bg-gray-400'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor} ${className}`}>
      <span className={`w-2 h-2 rounded-full mr-1.5 ${config.dotColor}`}></span>
      {config.label}
    </span>
  );
};

export default VehicleStatusBadge;